
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.369 10.913c0-.681-.057-1.361-.173-2.033H10.7v3.851h5.439a4.61 4.61 0 01-.693 1.724c-.346.522-.794.97-1.319 1.315v2.5h3.246c1.9-1.74 2.996-4.314 2.996-7.357z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M10.7 20.685c2.717 0 5.005-.886 6.673-2.414l-3.246-2.5c-.903.609-2.067.956-3.427.956-2.627 0-4.856-1.758-5.653-4.127H1.703v2.576a10.026 10.026 0 003.712 4.021 10.121 10.121 0 005.285 1.488z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M5.047 12.6a5.952 5.952 0 010-3.828V6.195H1.703a9.943 9.943 0 000 8.98L5.047 12.6z","fill":"#FBBC04"}}),_c('path',{attrs:{"d":"M10.7 4.644a5.488 5.488 0 013.862 1.5l2.874-2.854A9.712 9.712 0 0010.7.686c-1.867 0-3.696.515-5.285 1.488a10.026 10.026 0 00-3.712 4.021l3.344 2.577c.797-2.37 3.026-4.128 5.653-4.128z","fill":"#EA4335"}})])
          )
        }
      }
    